import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef, ViewEncapsulation } from '@angular/core';
import { IMTab } from '@mining/ui/card-body-container';

@Component({
  selector: 'm-single-body-container',
  exportAs: 'mSingleBodyContainer',
  template: `
    <div class="m-single-body-container">
      <ng-content select="m-page-banner"></ng-content>
      <nz-card
        class="m-single-body-nz-card"
        *ngIf="mTitle || mExtraRef"
        nzBorderless="true"
        [nzTitle]="mTitle ? titleTemplate : undefined"
        [nzExtra]="extraTemplate"
      >
        <ng-template #titleTemplate>
          <i
            nz-icon
            *ngIf="mTitle.icon"
            class="m-single-body-tab-icon"
            nz-tooltip
            [nzTooltipTitle]="mTitle.tooltipText"
            [nzType]="mTitle.icon"
          ></i>
          {{ mTitle.name }}
          <i *ngIf="mShowBack" (click)="clickBack()" class="m-single-body-back-icon" nz-icon nzType="arrow-left" nzTheme="outline"></i>
        </ng-template>
        <ng-template *ngIf="mCardTabRef" [ngTemplateOutlet]="mCardTabRef"></ng-template>
        <div class="m-single-body-content-container">
          <ng-template *ngIf="mContentRef" [ngTemplateOutlet]="mContentRef"></ng-template>
        </div>
      </nz-card>
      <ng-template #extraTemplate>
        <ng-template *ngIf="mExtraRef" [ngTemplateOutlet]="mExtraRef"></ng-template>
      </ng-template>
      <nz-card *ngIf="!mTitle && !mExtraRef" class="m-single-body-nz-card m-single-body-padding" nzBorderless="true">
        <div class="m-single-body-content-container">
          <ng-template *ngIf="mContentRef" [ngTemplateOutlet]="mContentRef"></ng-template>
        </div>
      </nz-card>
    </div>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: false
})
export class MSingleBodyContainerComponent {
  @Input() mTitle!: IMTab;
  @Input() mShowBack: boolean = true;
  @Input() mContentRef?: TemplateRef<void>;
  @Input() mCardTabRef?: TemplateRef<void>;
  @Input() mExtraRef?: TemplateRef<void>;

  @Output() readonly mBack = new EventEmitter<void>();

  clickBack(): void {
    this.mBack.emit();
  }
}
